import React from 'react';
import Box from '@amzn/awsui-components-react/polaris/box';
import { TableProps } from '@amzn/awsui-components-react/polaris/table';
import * as APIt from '../API';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Button from '@amzn/awsui-components-react/polaris/button';

function maskedComparator(a: boolean | undefined | null, b: boolean | undefined | null): number {
  const getTextVal = (masked: boolean | undefined | null) => masked ? 'Masked' : (masked === null || masked === undefined) ? 'Unknown' : 'Unmasked';

  const aMaskedText = getTextVal(a);
  const bMaskedText = getTextVal(b);
  return (aMaskedText.localeCompare(bMaskedText) )
};

export const ColumnDefinitions: TableProps.ColumnDefinition<APIt.ChildDevice>[] = [
  {
    id: 'Child_DeviceID',
    header: 'Child_DeviceID',
    cell: (item: APIt.ChildDevice) => item.Child_DeviceID
  },
  {
    id: 'DeviceName',
    header: 'Device Name',
    cell: (e: APIt.ChildDevice) => e.DeviceName,
    sortingField: 'DeviceName'
  },
  {
    id: 'Masked',
    header: 'Status',
    cell: (e: APIt.ChildDevice) => e.Masked ? 'Masked' : (e.Masked === null || e.Masked === undefined) ? 'Unknown' : 'Unmasked',
    sortingField: 'Masked',
    sortingComparator: (a: APIt.ChildDevice, b: APIt.ChildDevice) => maskedComparator(a.Masked, b.Masked)
  },
  {
    id: 'DoorForcedOpen',
    header: 'Door Forced Open',
    cell: (e: APIt.ChildDevice) => e.DoorForcedMasked ? 'Masked' : (e.DoorForcedMasked === null || e.DoorForcedMasked === undefined) ? 'Unknown' : 'Unmasked',
    sortingField: 'DoorForcedOpen',
    sortingComparator: (a: APIt.ChildDevice, b: APIt.ChildDevice) => maskedComparator(a.DoorForcedMasked, b.DoorForcedMasked)
  },
  {
    id: 'DoorHeldOpen',
    header: 'Door Held Open',
    cell: (e: APIt.ChildDevice) => e.DoorHeldMasked ? 'Masked' : (e.DoorHeldMasked === null || e.DoorHeldMasked === undefined) ? 'Unknown' : 'Unmasked',
    sortingField: 'DoorHeldOpen',
    sortingComparator: (a: APIt.ChildDevice, b: APIt.ChildDevice) => maskedComparator(a.DoorHeldMasked, b.DoorHeldMasked)
  },
  {
    id: 'Mode',
    header: 'Mode',
    cell: (e: APIt.ChildDevice) => e.Mode || 'Unknown',
    sortingField: 'Mode',
    width: 200
  },
];

interface EmptyStateProps {
  title: string
}

export function TableEmptyState({title}: EmptyStateProps) {
  return (
    <Box textAlign='center' color='inherit'>
      <Box variant='strong' textAlign='center' color='inherit'>
        {title}
      </Box>
    </Box>
  );
}

export const TableNoMatchState = (props: { onClearFilter: any | undefined; }) => (
  <Box margin={{ vertical: 'xs' }} textAlign='center' color='inherit'>
    <SpaceBetween size='xxs'>
      <div>
        <b>No matches</b>
        <Box variant='p' color='inherit'>
          We can't find a match.
        </Box>
      </div>
      <Button onClick={props.onClearFilter}>Clear filter</Button>
    </SpaceBetween>
  </Box>
);

export const DefaultPageSize = {
  pageSize: 100
}

export const PaginationLabels = {
  nextPageLabel: 'Next page',
  pageLabel: (pageNumber: number) => `Go to page ${pageNumber}`,
  previousPageLabel: 'Previous page'
};
